import { objectToQueryString } from 'site-modules/shared/utils/string';
import { getQuery } from 'client/utils/location';

export const getPersonalizedSearchPageRoute = () => `/search/`;

export const getPersonalizedSearchRouteWithKeyParam = searchId =>
  searchId
    ? `${getPersonalizedSearchPageRoute()}?${objectToQueryString({ key: searchId })}`
    : getPersonalizedSearchPageRoute();

export const hasUtmParam = location => {
  const params = getQuery(typeof window !== 'undefined' ? window.location : location);
  return !params.key && params.utm_source === 'userzoom';
};
